module.exports = __webpack_public_path__ + "static/media/field.3c9a0605.jpg";